import { Injectable } from "@angular/core";
import { map, of } from "rxjs";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PriceService {
  /**
   * Every registration is charged: there is no login anymore, and whitelabels are paying
   * customers too, so the notion of free access no longer exists.
   */
  price$(product: string){
    return of(product).pipe(
      map(product => {
        switch(product) {
          case "isni":
            return environment.stripe.products.registrationIsni.price;
          case "isrc":
            return environment.stripe.products.registrationIsrc.price;
          default:
            return 0
        }
      }),
      map(price => price / 100)
    )
  }
}
